(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pol-review-rotator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pol-review-rotator')) {
    customElements.define('pol-review-rotator', class extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('.pol-rr__card')];
        if (this.cards.length < 2) return;
        this.i = 0;
        this.querySelector('[data-next]')?.addEventListener('click', () => { this.go(this.i + 1); this.restart(); });
        this.querySelector('[data-prev]')?.addEventListener('click', () => { this.go(this.i - 1); this.restart(); });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      go(n) {
        const len = this.cards.length;
        this.i = (n + len) % len;
        this.cards.forEach((c, k) => { c.classList.toggle('is-active', k === this.i); c.setAttribute('aria-hidden', k === this.i ? 'false' : 'true'); });
        const cur = this.querySelector('[data-current]');
        if (cur) cur.textContent = this.i + 1;
      }
      stop() { clearInterval(this.t); }
      restart() {
        this.stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.t = setInterval(() => this.go(this.i + 1), Number(this.dataset.interval) || 5000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
